import {DialogContent, DialogTitle} from "@mui/material";
import {Dialog2} from "../../../misc/Dialog2";
import {SmoothActionBar} from "../../../misc/SmoothActionBar";
import {FindOrCreateCompany} from "../../project/manage/summary/FindOrCreateCompany";
import React from "react";
import {Company} from "../../../api/Companies";

export function AskForContractor(props: {
    onDone(value: Company|null): void
}) {
    const [value, setValue] = React.useState<Company|null>(null);

    const submit = () => props.onDone(value);

    return (
        <Dialog2 open onClose={() => props.onDone(null)} onEnterPress={submit}>
            <DialogTitle>Choose Company</DialogTitle>
            <DialogContent>
                <FindOrCreateCompany value={value} kind={"contractor"} label={"Contractor"} onChange={setValue} />
            </DialogContent>
            <SmoothActionBar
                onCancel={() => props.onDone(null)}
                onSubmit={submit}
            />
        </Dialog2>
    )
}